import { createAction, props } from '@ngrx/store';

const actionKey = '[Delivery]';

export const LoadDelivery = createAction(`${actionKey} Load state`, props<{ payload: string }>());

export const LoadDeliverySuccess = createAction(
  `${actionKey}  Load state success`,
  props<{ payload: any }>(),
);

export const LoadDeliveryFail = createAction(`${actionKey}  Load state fail`);

export const SetShareState = createAction(
  `${actionKey} Set share state`,
  props<{ payload: boolean }>(),
);

export const GetDeliveryEmailText = createAction(
  `${actionKey} Get Delivery Email Text`,
  props<{ payload: string }>(),
);

export const SetDeliveryEmailText = createAction(
  `${actionKey} Set Delivery Email Text`,
  props<{ payload: string }>(),
);

export const SetDeliveryLoading = createAction(
  `${actionKey} Set Delivery loading`,
  props<{ payload: boolean }>(),
);
